import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CircularProgress from "@mui/material/CircularProgress";

interface DialogProps {
    open: boolean;
    title: string;
    description: string;
    confirmButtonText: string;
    cancelButtonText: string;
    isLoading?: boolean;
    action: () => void;
    handler: () => void;
}

export default function FinancialDialog(props: DialogProps) {
    return (
        <Dialog
            open={props.open}
            onClose={(event, reason) => {
                if (props.isLoading) return;
                props.handler();
            }}
            aria-labelledby="financial-dialog-title"
            aria-describedby="financial-dialog-description"
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                    padding: "8px",
                },
            }}
        >
            <DialogTitle id="financial-dialog-title" sx={{ color: "#004A78", fontWeight: "bold" }}>
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="financial-dialog-description" sx={{ color: "#303972" }}>
                    {props.description}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: "16px" }}>
                <Button onClick={props.handler} disabled={props.isLoading} sx={{ color: "#637381" }}>
                    {props.cancelButtonText}
                </Button>
                <Button
                    onClick={() => {
                        props.action();
                    }}
                    variant="contained"
                    disabled={props.isLoading}
                    sx={{
                        background: "#004A78",
                        borderRadius: "8px",
                        minWidth: "120px",
                        "&:hover": {
                            bgcolor: "#226C9A",
                        },
                    }}
                    autoFocus
                >
                    {props.isLoading ? <CircularProgress size={24} color="inherit" /> : props.confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
